<template>
	<div
		v-show="bannerVisible"
		class="banner-component"
		:style="{
			'background-color': currentBannerType.backgroundColor,
			color: currentBannerType.textColor,
		}"
	>
		<div class="message">
			<slot></slot>
		</div>
		<i
			v-if="showCloseButton"
			lass="fas fa-times close-icon"
			@click="closeBanner"
		></i>
	</div>
</template>

<script>
export default {
    name: 'Banner',
    data: () => ({
        bannerTypes: [
            {type: 'success', backgroundColor: '', textColor: '#707070'},
            {type: 'info', backgroundColor: '#E4F0FC', textColor: '#707070'},
            {type: 'warning', backgroundColor: '', textColor: '#707070'},
            {type: 'error', backgroundColor: '', textColor: '#707070'},
            {
                type: 'custom',
                backgroundColor: '#FCFCFC',
                textColor: '#707070',
            },
        ],
        currentBannerType: 'custom',
        bannerVisible: true,
    }),
    props: {
        backgroundColor: {
            type: String,
            default: '',
        },
        textColor: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'info',
        },
        showCloseButton: {
            type: Boolean,
            default: false,
        },
    },
    mounted: function() {
        this.currentBannerType = this.bannerTypes.find(
            (bannerType) => bannerType.type == this.type,
        );
        if (!this.currentBannerType) {
            this.currentBannerType == this.bannerTypes[1];
        }
    },
    methods: {
        openBanner: function() {
            this.bannerVisible = true;
        },
        closeBanner: function() {
            this.bannerVisible = false;
        },
    },
    delimiters: ['{%', '%}'],
};
</script>

<style>
.banner-component {
	background-color: #e4f0fc;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 16px 42px;
	font-size: 16px;
	line-height: 22px;
	text-align: left;
	border-radius: 9px;
}
.banner-component .close-icon {
	font-size: 16px;
	font-weight: 700;
	cursor: pointer;
}
</style>
